export const RESPONSE_CANCELED_NOTICE = "*Response canceled.*";

export function appendCanceledNotice(messages = [], messageId) {
  const messageIndex = messages.findIndex(
    (message) => message.messageId === messageId,
  );
  if (messageIndex === -1) {
    return messages;
  }

  const answer = messages[messageIndex];
  const answerText = answer.message || "";
  if (
    !answerText.trim() ||
    answerText.trimEnd().endsWith(RESPONSE_CANCELED_NOTICE)
  ) {
    return messages;
  }

  const updatedMessages = [...messages];
  updatedMessages[messageIndex] = {
    ...answer,
    message: `${answerText.trimEnd()}\n\n${RESPONSE_CANCELED_NOTICE}`,
  };

  return updatedMessages;
}
